










































































































































import { ROUTES } from "@/constants/routes";
import { App } from "@/model/App";
import Vue from "vue";
import LoadingDestore from "@/components/LoadingDestore.vue";
import Update from "@/components/Update.vue";
import urls from "@/constants/urls";
import { PayloadRemoveApp, StateRemoveApp } from "@/store/app/types_app";
import { launchToast } from "@/utils/toast";
import { mapGetters } from "vuex";
import Report from "@/components/Report.vue";

export default Vue.extend({
  name: "DeSappDetails",
  components: { Report, LoadingDestore, Update },
  data(): {
    app: App;
    isLoading: boolean;
    appAuthor: string;
    appAuthorName: string;
    appMedia: any[];
    sessionId: string;
    isReportModalActive: boolean;
    isEditModalActive: boolean;
    error: boolean;
  } {
    return {
      app: {
        appName: "",
        appSummary: "",
        appUrl: "",
        appBanner: null,
        appCategories: [],
        appDescription: "",
        appIcon: null,
        appImages: [],
        appVideos: [],
      },
      isLoading: true,
      appAuthor: "",
      appAuthorName: "",
      appMedia: [],
      sessionId: this.$store.getters.getSessionId,
      isReportModalActive: false,
      isEditModalActive: false,
      error: false,
    };
  },
  computed: {
    ...mapGetters(["getStateRemoveApp", "getWebId"]),
    getAppAuthorName(): string {
      if (this.appAuthorName == "") {
        return "";
      }
      return "@" + this.appAuthorName;
    },
    getAltIcon(): string {
      return "Icon of " + this.app.appName;
    },
    getAltImage(): string {
      return "Image of " + this.app.appName;
    },
    getErrorMessageStyle() {
      return {
        "font-size": "4rem",
        color: "#20273E",
      };
    },
  },
  watch: {
    appAuthor() {
      const regex = /https:\/\/(.*).inrupt/;
      if (this.appAuthor) {
        const results = this.appAuthor.match(regex);
        if (results && results.length > 0) {
          this.appAuthorName = results[1];
        } else {
          this.appAuthorName = "Unknown";
        }
      }
    },
    getStateRemoveApp: function () {
      if (this.getStateRemoveApp === StateRemoveApp.loading) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
        const toastMessage =
          this.getStateRemoveApp === StateRemoveApp.success
            ? "The app has been successfully removed"
            : "App could not be removed";
        const toastType =
          this.getStateRemoveApp === StateRemoveApp.success
            ? "is-success"
            : "is-danger";
        launchToast(toastMessage, toastType);
        if (this.getStateRemoveApp === StateRemoveApp.success) {
          const eventEmit = {
            showHome: true,
            showRes: false,
          };
          this.$store.dispatch("changeShowMainComponent", eventEmit);
          this.$router.push({
            name: ROUTES.HOME.name,
          });
        }
      }
    },
  },
  created() {
    const appName = decodeURIComponent(this.$route.params.name);
    const URL = urls.url_to_details + appName;
    const options = {
      method: "GET", // or 'PUT'
    };
    fetch(URL,options)
      .then((response) => response.json())
      .then((data) => {
        this.app = data.message as App;
        this.appAuthor = data.message.appAuthor;
        this.isLoading = false;
        this.appMedia.push({ type: "i", src: this.app.appBanner });
        this.app.appImages.forEach((val: any) =>
          this.appMedia.push({ type: "i", src: val })
        );
        this.app.appVideos.forEach((val: any) =>
          this.appMedia.push({ type: "v", src: val })
        );
      })
      .catch(() => {
        this.error = true;
      });
  },
  methods: {
    goBack(): void {
      this.$router.go(-1);
    },
    goToAppWebb(url: string): void {
      window.open(url, "_blank");
    },
    clickRemove(): void {
      this.$buefy.dialog.confirm({
        title: "Deleting application",
        message:
          "Are you sure you want to <b>delete</b> this application? This action cannot be undone.",
        confirmText: "Delete Application",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.removeApp(),
      });
    },
    removeApp(): void {
      const payloadRemove: PayloadRemoveApp = {
        appName: this.app.appName,
        sessionId: this.sessionId,
      };
      this.$store.dispatch("removeApp", payloadRemove);
    },
    clickReport(): void {
      this.isReportModalActive = true;
    },
    clickEdit(): void {
      this.isEditModalActive = true;
    },
    receiveAppUpdated(event: App): void {
      this.app = event;
    },
  },
});
